module.exports = __webpack_public_path__ + "img/lrc-form.ee133b17.png";